import { render, staticRenderFns } from "./AppPromoLinks.vue?vue&type=template&id=b975e6d0&scoped=true"
import script from "./AppPromoLinks.vue?vue&type=script&lang=js"
export * from "./AppPromoLinks.vue?vue&type=script&lang=js"
import style0 from "./AppPromoLinks.vue?vue&type=style&index=0&id=b975e6d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b975e6d0",
  null
  
)

export default component.exports